import { useCallback } from 'react';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { showUnavailableOnWeb } from 'utils/webGate';
const useHandleOpenInterestPot = () => {
    const navigation = useMainStackNavigation();
    const navigateToOpenInterestPot = useCallback(() => {
        if (showUnavailableOnWeb('emma://save?tab=pots', 'Create a Pot')) {
            return;
        }
        navigation.navigateDeprecated('SelectPotType');
    }, []);
    return navigateToOpenInterestPot;
};
export default useHandleOpenInterestPot;
